{
  "segments": {
    "new": "Bees",
    "active": "Aktif",
    "vip": "VIP",
    "at_risk": "Ci tolof-tolof",
    "churned": "Dem na",
    "wholesale": "Grosist"
  },
  "loyalty": {
    "bronze": "Bronze",
    "silver": "Xaalis",
    "gold": "Wurus",
    "platinum": "Platin"
  },
  "languages": {
    "fr": "Fransse",
    "wo": "Wolof",
    "en": "Angale"
  },
  "list": {
    "title": "Kiliyaan yi",
    "all": "Yépp",
    "search_placeholder": "Seet ci tur walla telefon...",
    "empty": "Amul kiliyaan",
    "empty_description": "Amul kiliyaan bu baax ak li ngay seet",
    "col_name": "Tur",
    "col_phone": "Telefon",
    "col_segment": "Bokk",
    "col_total_spent": "Tollu dépense",
    "col_last_order": "Komand bu mujj",
    "col_loyalty": "Fidélité",
    "load_error": "Mënul jële kiliyaan yi",
    "load_error_hint": "Seetlu sa connexion te jéemaat."
  },
  "customer": {
    "not_found": "Gisul kiliyaan bi",
    "total_orders": "Tollu komand yi",
    "total_spent": "Tollu dépense",
    "last_order": "Komand bu mujj",
    "member_since": "Kiliyaan dale na ci",
    "details": "Xibaar yi",
    "preferred_payment": "Yoonu fey bu la neex",
    "preferred_language": "Làkk bu la neex",
    "addresses": "Adres yi",
    "tags": "Etiket yi",
    "notes": "Not yi",
    "no_notes": "Amul not ci kiliyaan bii",
    "add_note": "Yokk",
    "add_note_placeholder": "Yokk benn not..."
  },
  "dashboard": {
    "title": "Bokk yi ci kiliyaan",
    "total_customers": "kiliyaan yépp",
    "clients": "kiliyaan",
    "avg_spend": "Dépense mooytu",
    "create_campaign": "Sos kampany"
  },
  "campaign": {
    "create_title": "Kampany bu bees",
    "name": "Tur kampany bi",
    "name_placeholder": "Misaal : Promo Koor Countre Dairy",
    "type": "Yoon",
    "types": {
      "sms": "SMS",
      "whatsapp": "WhatsApp",
      "email": "Email"
    },
    "target_segment": "Bokk bu ñu jëmë",
    "estimated_reach": "kiliyaan dinañu jot",
    "message": "Bataaxal",
    "message_placeholder": "Bind sa bataaxal fii...",
    "characters": "karakteer",
    "preview": "Xool",
    "schedule": "Bés ak waxtu yonnee",
    "cancel": "Neenal",
    "create": "Sos kampany bi",
    "status": {
      "draft": "Bruyon",
      "scheduled": "Planifiye",
      "sending": "Ñuy yonnee",
      "completed": "Jeex na",
      "cancelled": "Neenal na"
    }
  }
}
